import React, { useRef } from 'react'
import AppHeader from '../../components/main/AppHeader'
import './style.css';
import AppFooter from '../../components/main/AppFooter';
import { useNavigate } from 'react-router-dom';
import data from '../../constant/data.json';
import ProjectListCard from './components/ProjectListCard';
import ContactSection from '../home/sections/ContactSection';
export default function ProjectsListPage(props) {
    const navigate = useNavigate();
    const onLogoClick =()=>{
        navigate("/")
    }
    
   
    return (
        <div  className='home-main'>
            <AppHeader hideMenu onLogoClick={onLogoClick} />
                <div className='portfolio-header'>
                <p className='portfolio-header-text'>PORTFOLIO</p>
                <img src={require("../../assets/images/app.png")} className='portfolio-app' />
                <img src={require("../../assets/images/web.png")} className='portfolio-web' />
                <img src={require("../../assets/images/backend.png")} className='portfolio-backend' />
                </div>
                <div className='project-list-container'>
                {data.projects.map((project,index)=>{
                    return <ProjectListCard project={project} key={project.id} />
                })}
                </div>
                
                  <ContactSection notHomePage={true} />
            <AppFooter />
        </div>
    )
}
